import {utils_tool} from '@/tool';
import React from 'react'
import {WizTableForm} from '@/containers/common';
import moment from "moment";

let {$$, checkStrLength} = utils_tool;

const organizationConfig = WizTableForm.Config.organization(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})
//配置项
let componentName = 'storeReport'


const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "品牌",
    name: "brandId",
    searchItem: {
      diy: WizTableForm,
      selectType: "radio",
      ...organizationConfig
    }
  },
  {
    title: '品牌',
    name: 'brandName',
    tableItem: {width: 150}
  },
  {
    title: "区域",
    name: "zone",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: "类型",
    name: "importType",
    dataIndex: "importType",
    dict: [
      {code: 0, codeName: "销售"},
      {code: 1, codeName: "售后"},
    ],
    tableItem: {
      width: 150
    },
    searchItem: {
      type: "select",
    },
  },
  {
    title: "经销商名称",
    name: "dealerName",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: "经销商代码",
    name: "dealerCode",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: '数据截止时间',
    name: 'dataEndTime',
    searchItem: {
      type: 'date',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: '数据截止时间',
    name: 'dataEndTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  },
  {
    title: '导入时间',
    name: 'importTime',
    tableItem: {
      render: (text, record) => {
        return formatterDate(text)
      }
    }
  }
];

const templateConfig = (data) => {
  const { _this} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (val) => {
            if (val['dataEndTime']) {
              val['dataEndTime'] = moment(val['dataEndTime']).format("YYYY-MM-DD")+' 00:00:00';
            }else {
              val['dataEndTime'] = undefined;
            }
            return val
          },
          collapse: false,
          buttonSort: ['import'],
          buttons: [
            {
              key: "import",
              custom: true,
              params: {children: "导入单店报告"},
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/storeReport/storeReportList/import"
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          // rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/pageInfoList`,
    payload: {
      key: `${componentName}@pageInfoList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
